<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <PageTitle />
        <b-card>
          <div class="bd-example">
            <dl class="row">
              <dt class="col-sm-3">{{$tc('page.generic.state', 1)}}</dt>
              <dd class="col-sm-9">{{ status(pendingConsent.status.toLowerCase()) }}</dd>
              <dt class="col-sm-3">{{$t('pendingConsent.procedureList')}}</dt>
              <dd class="col-sm-9">{{ pendingConsent.procedureList.length > 0 ? pendingConsent.procedureList[0].code : '' }}</dd>
              <dt class="col-sm-3">{{$t('pendingConsent.modelCode')}}</dt>
              <dd class="col-sm-9">{{ pendingConsent.modelCode }}</dd>
              <dt class="col-sm-3">{{$t('pendingConsent.patientId')}}</dt>
              <dd class="col-sm-9">{{ pendingConsent.patientId }}</dd>
              <dt class="col-sm-3">{{$t('pendingConsent.sourceCode')}}</dt>
              <dd class="col-sm-9">{{ pendingConsent.sourceCode }}</dd>
              <dt class="col-sm-3">{{$t('page.generic.creationDate')}}</dt>
              <dd class="col-sm-9">{{ formatDate(pendingConsent.dateCreated) }}</dd>
              <dt class="col-sm-3">{{$t('page.generic.expirationDate')}}</dt>
              <dd class="col-sm-9">{{ formatDate(pendingConsent.expirationDate) }}</dd>
              <dt class="col-sm-3">{{$t('pendingConsent.relations')}}</dt>
              <dd class="col-sm-9">
                <ul>
                  <li v-for="relation in pendingConsent.relationList" :key="relation.type">
                    {{ printRelation(relation) }}
                  </li>
                </ul>
              </dd>
            </dl>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import miniToastr from "mini-toastr";
import PendingConsentService from "../../services/PendingConsentService";
import PageTitle from "../../components/PageTitle";
import i18n from '@/config/i18n'
import moment from "moment";
const pendingConsentService = PendingConsentService.build();

export default {
  name: "PendingConsentShow",
  components: {
    PageTitle
  },
  props: {
    id: {
      required: true
    }
  },
  data() {
    return {
      pendingConsent: ''
    }
  },
  created() {
    miniToastr.init();
    miniToastr.setIcon('info', 'i', {'class': 'fas fa-info-circle'});
    this.fetchData()
  },
  methods: {
    status (status = 'unknown') {
      return i18n.t(`pendingConsent.status.${status}`)
    },
    formatDate (date) {
      return moment(date).format('DD/MM/YYYY');
    },
    async fetchData() {
      this.pendingConsent = await pendingConsentService.read(this.id)
    },
    printRelation(relation) {
      let creatorAppId = ""
      if (relation.creatorAppId)
        creatorAppId = ` (${relation.creatorAppId})`
      return `${relation.type}${creatorAppId}: ${relation.value}`
    }
  }
}
</script>
